import React, { Component } from 'react';
import { connect } from 'react-redux';
import Contact2 from './Contact2'

class Contact extends Component {

//tinyMCE doesnt work right if its on the main page of a route for some reason

  render(){
  	const {auth} = this.props
  	if (!auth.uid) return <Redirect to='/signin' />

  	return(
  		
  		<div className='container'>
  		{ auth &&
  		<Contact2/>
      }
  		</div>

  	)
  }

}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth
  }
}


export default connect(mapStateToProps)(Contact)